export default __webpack_public_path__ + "static/media/4.7a6da45a.png";